import { createApp } from 'vue'
import App from './App.vue'
import { ensureParentLogin, startReauthorize } from '@/utils/wechat/oauth'

// 非生产包启用 vConsole，方便微信内真机调试；生产包按条件摇树，不引入该依赖。
if (import.meta.env.MODE !== 'production') {
  import('vconsole').then(({ default: VConsole }) => new VConsole())
}

async function bootstrap() {
  const app = createApp(App)
  // 挂载前完成认证：自动模式可能整页跳转微信授权或兑换回跳 code，
  // 手动模式直接返回，由路由守卫把无 token 的用户送到 code 输入页。
  await ensureParentLogin()
  const { default: router } = await import('./router')
  app.use(router)
  await router.isReady()
  // token 失效：自动模式先静默重授权一次，否则回到登录页。
  window.addEventListener('auth:expired', () => {
    if (!startReauthorize()) router.replace('/login')
  })
  app.mount('#app')
}

bootstrap()
